import type { FollowUpActionStatus } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'
import { useMutation, useQueryClient } from 'react-query'

type UseIncidentActionStatusProps = {
  onUpdateSuccess?: () => void
}

type UpdateActionStatusParams = {
  incidentReportId: string
  actionId: string
  status: FollowUpActionStatus
  ownerId?: string
}

const useIncidentActionStatus = ({
  onUpdateSuccess
}: UseIncidentActionStatusProps) => {
  const queryClient = useQueryClient()

  const handleError = (err: unknown) => {
    showToast({
      title: 'Update failed' as string,
      type: 'error'
    })
  }

  const updateActionStatusFunction = (params: UpdateActionStatusParams) =>
    postJSON({
      url: `list/incident-report/${params.incidentReportId}/actions/${params.actionId}`,
      method: 'PATCH',
      json: {
        status: params.status,
        assignedUserId: params.ownerId ? params.ownerId : undefined
      },
      responseType: 'text'
    })

  const { mutateAsync: updateActionStatus, isLoading } = useMutation<
    any,
    unknown,
    UpdateActionStatusParams
  >(['incident-action-status'], updateActionStatusFunction, {
    onSuccess: () => {
      onUpdateSuccess?.()
      queryClient.invalidateQueries(['incident-actions'])
      queryClient.invalidateQueries(['incident-report'])
      queryClient.invalidateQueries(['list-incidents'])
    },
    onError: (err) => handleError(err)
  })

  return {
    updateActionStatus,
    isLoading
  }
}

export default useIncidentActionStatus
